import { render, staticRenderFns } from "./DataCollectionViewComponent.vue?vue&type=template&id=362c455f&"
import script from "./DataCollectionViewComponent.vue?vue&type=script&lang=js&"
export * from "./DataCollectionViewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports